import { BeamButton } from "./BeamButton";
import useTranslation from "../../client/hooks/useTranslation";
import ScrollAnimation from "./ScrollAnimation";
import IntegrationsCard from "./IntegrationsCard";
import BrokersSection from "./BrokersSection";

export default function FreePlanHighlight() {
  const t = useTranslation();

  return (
    <section className="relative py-16 sm:py-20 overflow-hidden mx-[calc(-50vw+50%)] w-screen">
      {/* Subtle bg */}
      <div className="pointer-events-none absolute inset-0 bg-background-subtle" />
      {/* Grid overlay */}
      <div
        className="pointer-events-none absolute inset-0 opacity-30"
        style={{
          backgroundImage: `
            linear-gradient(rgba(0,201,167,0.04) 1px, transparent 1px),
            linear-gradient(90deg, rgba(0,201,167,0.04) 1px, transparent 1px)
          `,
          backgroundSize: "40px 40px",
        }}
      />

      <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-8">
        <ScrollAnimation direction="up">
          <div className="mx-auto max-w-2xl text-center mb-12">
            <p className="text-xs font-semibold uppercase tracking-widest text-primary mb-3">
              {t.landing.freePlan.overline}
            </p>
            <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
              {t.landing.freePlan.title}
            </h2>
            <p className="mt-4 text-muted-foreground">
              {t.landing.freePlan.subtitle}
            </p>
          </div>
        </ScrollAnimation>

        <ScrollAnimation direction="up" delay={120}>
          <IntegrationsCard showFooter={false} />
        </ScrollAnimation>

        <ScrollAnimation direction="up" delay={250}>
          <BrokersSection />
        </ScrollAnimation>

        <ScrollAnimation direction="up" delay={400}>
          <div className="mt-10 flex justify-center">
            <BeamButton className="px-8" showArrow>
              {t.landing.freePlan.cta}
            </BeamButton>
          </div>
        </ScrollAnimation>
      </div>
    </section>
  );
}
